{
    "DataTable_AreYouSure": "Weet u zeker dat u het volgende wilt verwijderen? \n \n **{}**",
    "NAME": "LanguageDataTable"
}